import { render, staticRenderFns } from "./KusResultRemoveGroupDialog.vue?vue&type=template&id=54700285"
import script from "./KusResultRemoveGroupDialog.vue?vue&type=script&lang=js"
export * from "./KusResultRemoveGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports